import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detailtrigger",
  "use": "icon-detailtrigger-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-detailtrigger\">\n  <path color=\"currentColor\" d=\"M16,0v2H0V0H16z M0,6h12V4H0V6z M0,10h8V8H0V10z\" />\n  <polygon fill=\"currentColor\" points=\"20,8 16,8 16,4 14,4 14,8 10,8 10,10 14,10 14,14 16,14 16,10 20,10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol